import { Injectable } from '@angular/core';
import { Exchange, Product } from '@models';
import { FundOverviewService } from '@products/services/fund-overview.service';
import {
  ConfigurationId,
  TradingInformationState,
  ProductDetailConfiguration,
} from '@types';
import { Logger } from '@utils/logger';
import { Subject } from 'rxjs';
import tradingInformationQuery from '@graphql/overview/trading-info.graphql';

const logger = Logger.getLogger('TradingInformationService');

@Injectable({
  providedIn: 'root',
})
export class TradingInformationService {
  private state: TradingInformationState = {};
  private configurationName: ConfigurationId;
  private exchangesTrading: Exchange[];
  private tradingInformationStateSubject: Subject<TradingInformationState>;

  constructor(private overviewService: FundOverviewService) {
    this.tradingInformationStateSubject = new Subject();
  }

  public get tradingInformationState(): Subject<TradingInformationState> {
    return this.tradingInformationStateSubject;
  }

  /**
   * Call register method of fund overview service.
   */
  public populate(
    productDetailConfiguration: ProductDetailConfiguration
  ): void {
    this.overviewService
      .register(tradingInformationQuery, {
        configurationName: this.getConfigurationName(),
        fundId: productDetailConfiguration.fundId,
        shareClassCode: productDetailConfiguration.shareClassCode,
      })

      .subscribe((product: Product) => {
        if (product) {
          this.mapState(product);
        }
      });
  }

  mapState(product: Product) {
    const shareClassData = product.shareClasses[0];
    this.exchangesTrading = shareClassData?.exchanges;
    this.state.data = { exchanges: this.exchangesTrading };
    this.tradingInformationStateSubject.next(this.state);
  }

  setConfigurationName(configurationName: ConfigurationId) {
    this.configurationName = configurationName;
  }

  getConfigurationName(): ConfigurationId {
    return this.configurationName;
  }
}
